import React, { useState } from 'react';
import { api } from '../api/client';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

import LiquidEther from "../components/ui/liquidether"

export default function Register() {
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const[errr, setErrr] = useState('');
  const navigate = useNavigate('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setErrr('');
    
    let pswrd = formData.password;
    let hasSpecialChar = false;
    for (let i = 0; i < pswrd.length; i++) {
        let code = pswrd.charCodeAt(i);
        if ( (code >= 33 && code <= 47) || 
             (code >= 58 && code <= 64) || 
             (code >= 91 && code <= 96) || 
             (code >= 123 && code <= 126) ) {
             hasSpecialChar = true;
             break;
        }
    }
    if (!hasSpecialChar) {
      setErrr("You must have a special character in your password");
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match, please try again");
      return;
    }
    try {
      const data = await api.auth.register({
        full_name: formData.full_name,
        email: formData.email,
        password: formData.password
      });
    
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      
      navigate('/dashboard');
    } catch (err) {
      console.error(err);
      const message = err.response?.data?.message || "Registration failed. Try again.";
      setError(message);
    }
  };

  return (
    <div className="relative flex flex-col justify-center items-center h-screen w-full overflow-hidden bg-black">
      <div className="absolute inset -0 z-0">
        <LiquidEther
          colors={[ '#5227FF', '#FF9FFC', '#B19EEF' ]}
          mouseForce={20}
          cursorSize={100}
          isViscous={false}
          viscous={30}
          iterationsViscous={32}
          iterationsPoisson={32}
          resolution={0.5}
          isBounce={false}
          autoDemo={true}
          autoSpeed={0.5}
          autoIntensity={2.2}
          takeoverDuration={0.25}
          autoResumeDelay={3000}
          autoRampDuration={0.6}
        />
      </div>
      <div className="relative z-10 flex flex-col items-center">
      <form onSubmit={handleRegister} className="p-8 bg-white rounded-xl shadow-lg w-96 space-y-4">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-slate-900">Create an Account</h1>
          <p className="text-slate-500 text-sm">Join TickedOff to track your progress</p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="full_name">Full Name</Label>
          <Input 
            id="full_name"
            name="full_name" 
            placeholder="John Doe" 
            required
            value={formData.full_name} 
            onChange={handleChange} 
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input 
            id="email"
            name="email" 
            type="email" 
            placeholder="john@example.com" 
            required
            value={formData.email} 
            onChange={handleChange} 
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input 
            id="password"
            name="password" 
            type="password" 
            placeholder="••••••••" 
            required
            value={formData.password} 
            onChange={handleChange} 
          />
        </div>

        {errr && (
          <div className="text-center text-sm mt-4 text-red-600">
            {errr};
          </div>
        )}

        <div className="space-y-2">
          <Label htmlFor="confirmPassword">Confirm Password</Label>
          <Input 
            id="confirmPassword"
            name="confirmPassword" 
            type="password" 
            placeholder="••••••••" 
            required
            value={formData.confirmPassword} 
            onChange={handleChange} 
          />
        </div>

        {error && (
          <div className="text-center text-sm text-red-600 font-medium">
            {error}
          </div>
        )}

        <Button type="submit" className="w-full bg-black hover:bg-gray-800 text-white">
          Sign Up
        </Button>

        <div className="text-center mt-4 text-sm">
          <span className="text-slate-500">Already have an account? </span>
          <Link to="/login" className="text-blue-600 font-semibold hover:underline">
            Log in
          </Link>
        </div>
      </form>
      </div>
    </div>
  );
}